// extracted by mini-css-extract-plugin
export var bubble = "_33-0";
export var container = "_33-f";
export var contrastBorder = "_33-g";
export var greyOut = "_33-2";
export var initialsColor0 = "_33-3";
export var initialsColor1 = "_33-4";
export var initialsColor10 = "_33-d";
export var initialsColor11 = "_33-e";
export var initialsColor2 = "_33-5";
export var initialsColor3 = "_33-6";
export var initialsColor4 = "_33-7";
export var initialsColor5 = "_33-8";
export var initialsColor6 = "_33-9";
export var initialsColor7 = "_33-a";
export var initialsColor8 = "_33-b";
export var initialsColor9 = "_33-c";
export var initialsWrapper = "_33-1";
export var large = "_33-l";
export var medium = "_33-k";
export var mediumSmall = "_33-j";
export var mediumSmallMedium = "_33-o";
export var micro = "_33-h";
export var small = "_33-i";
export var tiny = "_33-n";
export var xTiny = "_33-m";